export const blogs = [
  /*{
    title: 'My process for building software',
    description: 'In here, I share my thought process and personal framework for building great software.',
    publishedAt: '2025-06-31',
    slug: 'my-process-for-building-software',
  },*/
  {
    title: 'Creating Sentro',
    description: 'Creating a low-level tool to build and manage design systems at scale.',
    publishedAt: '2025-05-31',
    slug: 'creating-sentro',
  }
];